module.exports = "/assets/src/client/assets/logo-typographic-white.svg";